export default __webpack_public_path__ + "images/29256b6f96ce36bcc5d01d622dcb67e7-signature.svg";